import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useCurrency } from "../context/CurrencyContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ProductRecommendations = ({ slug }) => {
  const [items, setItems] = useState([]);
  const { formatPrice } = useCurrency();

  useEffect(() => {
    if (!slug) return;
    let cancelled = false;
    axios.get(`${API}/products/${slug}/recommendations`)
      .then(({ data }) => { if (!cancelled) setItems(data || []); })
      .catch(() => { if (!cancelled) setItems([]); });
    return () => { cancelled = true; };
  }, [slug]);

  if (!items.length) return null;

  return (
    <section data-testid="recos-section" className="border-t border-white/10 py-16 max-w-[1400px] mx-auto px-6 md:px-12">
      <div className="flex items-baseline justify-between mb-8">
        <div>
          <p className="label-caps text-[color:var(--gold)] text-[10px] tracking-[0.3em]">Vous aimerez aussi</p>
          <h3 className="font-serif text-2xl md:text-3xl text-white mt-2">Suggestions olfactives</h3>
        </div>
        <p className="text-white/40 text-xs italic">Choix basé sur vos notes préférées</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {items.map((p) => (
          <Link
            key={p.id}
            to={`/parfum/${p.slug}`}
            data-testid={`reco-card-${p.slug}`}
            className="group border border-white/10 hover:border-[color:var(--gold)]/50 transition-colors"
          >
            <div className="aspect-[4/5] overflow-hidden bg-[#0A0A0A]">
              {p.image_main && (
                <img
                  src={p.image_main}
                  alt={p.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              )}
            </div>
            <div className="p-5">
              <p className="text-white/40 text-[10px] label-caps tracking-[0.25em] mb-1">{p.brand || "MAISON DOUBA"}</p>
              <p className="text-white font-serif text-lg mb-2 group-hover:text-[color:var(--gold)] transition-colors">{p.name}</p>
              <p className="text-[color:var(--gold)] font-serif text-xl">{formatPrice(p.price_100ml || p.price || 0)}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default ProductRecommendations;
